<template>
  <div class="pl-2 m-auto w-90 mt-3 body-style">
    <div v-if="userLoginMessage.type === 99">
      <year-card-verify/>
    </div>
    <div v-else>
      <!--标题部分-->
      <div class="d-flex justify-content-between align-items-center p-2 pl-5 pt-3 pb-3 w-100 border-bottom">
        <h3 class="text-left font-weight-bold" style="background: #fcfcfc;">{{Number(paramStatus)| formatVar('yearCardStatus')}}</h3>
        <el-button type="text" class="mr-5" @click="$router.back()">返回上一页</el-button>
      </div>
      <!--主题内容-->
      <div class="d-center-between">
        <!--<div class="w-50">-->
          <img src="/images/public/annualFront.png" class="ml-5 mt-3 mb-3" height="168px" width="265px"/>
        <!--</div>-->
        <div class="pl-2 text-left mr-5">
          <h2 class="pt-2">黄金版旅游年卡</h2>
          <p class="pt-2">价格：
            <span class="pl-2">&yen;</span><span style="font-size:36px;font-weight: bold;">{{unitPrice}}</span>
            <span>元 / 张</span>
          </p>
          <p class="pt-2">数量：<span style="margin-left: 150px">x {{CardInfoList.num}}</span></p>
          <p class="pt-2">总计：<span class="text-danger h4" style="margin-left: 150px">{{subPrice}}</span> 元</p>
        </div>
      </div>
      <div class="border-top border-bottom pt-5 pb-3 text-left pl-5">
        <p class="h4">收件人：{{CardInfoList.contact}} <span class="pl-4">{{CardInfoList.mobile}}</span></p>
        <p class="text-muted pt-3">收货地址：{{CardInfoList.address}}</p>
      </div>
      <div class="d-center-between p-5 border-bottom" >
        <p>运费：{{CardInfoList.express_price}}元</p>
        <p>应付金额：<span class="text-danger h2">{{CardInfoList.price}}</span>元</p>
        <!--<div class="d-flex" style="width: 400px">-->
          <!--<ul class="d-flex flex-column align-items-end w-40">-->
            <!--<li>数量：</li>-->
            <!--<li>单价：</li>-->
            <!--<li>运费：</li>-->
            <!--<li>应付金额：</li>-->
          <!--</ul>-->
          <!--<ul class="d-flex flex-column align-items-end w-60">-->
            <!--<li>{{CardInfoList.num}}</li>-->
            <!--<li class="w-75 pb-1 d-center-between"><span>x</span><span>{{unitPrice.toFixed(2)}}</span></li>-->
            <!--<li class="w-75 pb-1 d-center-between border-bottom"><span>+</span><span>{{CardInfoList.express_price}}</span></li>-->
            <!--<li><span class="pb-1 mt-3 text-danger h3">{{CardInfoList.price}}</span>元</li>-->
          <!--</ul>-->
          <!--<ul class="d-flex align-items-end">-->
            <!--<li class="pb-small pl-1">元</li>-->
          <!--</ul>-->
        </div>
      </div>
      <!--状态码为1待付款 -->
      <div v-if="paramStatus == 1">
        <el-button type="primary" class="mt-5 mb-5" v-if="!QRcode" @click="getQRcode">付款二维码</el-button>
        <div class="d-center flex-column p-5" v-else>
          <img v-show="QRcode" class="border p-1 rounded" style="width: 150px; height: 150px;" :src="QRcode" alt="">
          <el-button type="primary" class="mt-3" @click="getQRcode">更新二维码</el-button>
        </div>
      </div>
      <!--状态码为2,3-->
      <div v-if="paramStatus == 2 || paramStatus == 3" class="pt-5 pb-5 d-flex justify-content-between">
        <div class="d-flex justify-content-between pl-5" style="width: 65%">
          <p class="text-muted">快递名称： <span class="h5 text-dark">{{CardInfoList.express_name ==''? '暂无数据':CardInfoList.express_name}}</span>
          </p>
          <p class="text-muted">订单号： <span class="h5 text-dark">{{CardInfoList.express_num == ''? '暂无数据':CardInfoList.express_num}}</span>
          </p>
        </div>
      </div>
      <p class="pr-5 h5 text-right pl-5 pb-5" v-if="paramStatus == 3">已付款{{CardInfoList.price}}元，已收货</p>
      <p class="pr-5 h5 text-right pl-5 pb-5" v-if="paramStatus == 2">已付款{{CardInfoList.price}}元，请耐心等待收货哦！</p>
    </div>
</template>

<script>
  import {mapState, mapActions,mapGetters} from 'vuex'
  import YearCardVerify from '../AnnualCard/YearCardVerify.vue'

  export default {
    name: 'PaymentDetail',
    components: {YearCardVerify},
    data() {
      return {
        QRcode: '',                     //付款二维码地址
        express_num: '',                //订单号
      }
    },
    computed: {
      ...mapState(['userLoginMessage', 'newMessageInform', 'CardInfoList']),
      ...mapGetters(['storeInfo']),
      paramId() {
        return this.$route.query.data
      },
      paramStatus() {
        return this.$route.query.status
      },
      subPrice() {
        let price = 0;
        if (this.CardInfoList.num < 20) price = 12;
        return this.CardInfoList.price - price;
      },
      unitPrice() {
        let unitPrice = 0;
        if (this.CardInfoList.num < 10000) {
          unitPrice = 128;
        } else {
          unitPrice = 118;
        }
        return unitPrice;
      },
    },
    mounted() {
      if (this.userLoginMessage.type !== 99) {
        this.getAnnualCardInfo({
          store_id: this.userLoginMessage.store_ids[0],
          id: this.paramId
        })
      }
    },
    watch: {
      newMessageInform() {
        if (this.newMessageInform.type === 12) {
          this.QRcode = '';
          this.$router.replace({name: 'PaymentDetail', query: {data: this.paramId, status: 2}});
        }
      },
    },
    methods: {
      ...mapActions(['getAnnualCardInfo']),
      /*获取付款二维码*/
      getQRcode() {
        let count = new Date().getTime();
        this.QRcode = this.BASE_URL + '/pc/Travel/getYearCardPayQrcode?needToken=' + this.userLoginMessage.token + '&needType=1&store_id=' + this.storeInfo.storeId + '&id=' + this.paramId + '&count=' + count;
      },
    }
  }
</script>
<style scoped lang="scss">
  .body-style {
    min-width: 800px;
    background: white;
    border: #f0f0f0 solid 1px;
    border-radius: 5px
  }
</style>
